import React from "react";

export const Testimonials = (props) => {
  return (
    <div id="testimonials">
      <div className="container">
        <div className="section-title text-center">
          <h2>Download RBD App </h2>
        </div>
        <div className="row">
          <div className="col-md-4">
            <h2>App Store</h2>
            <a href="https://apps.apple.com/us/app/broker-rbd/id6446393868">
              <img src="img/Applelogo.png" className="img-responsive" alt="" />
            </a>
          </div>
          <div className="col-md-4"></div>
          <div className="col-md-4">
            <h2>Play Store</h2>
            <a href="https://play.google.com/store/apps/details?id=com.brooker">
              <img src="img/google.png" className="img-responsive" alt="" />
            </a>
          </div>
          {/* {props.data
            ? props.data.map((d, i) => (
                <div key={`${d.name}-${i}`} className="col-md-4">
                  <div className="testimonial">
                    <div className="testimonial-image">
                      {" "}
                      <img src={d.img} alt="" />{" "}
                    </div>
                    <div className="testimonial-content">
                      <p>"{d.text}"</p>
                      <div className="testimonial-meta"> - {d.name} </div>
                    </div>
                  </div>
                </div>
              ))
            : "loading"} */}
        </div>
      </div>
    </div>
  );
};
